import { render, staticRenderFns } from "./PublicInterviews.vue?vue&type=template&id=1d96e688&"
import script from "./PublicInterviews.vue?vue&type=script&lang=js&"
export * from "./PublicInterviews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports